import { useState, useEffect } from "react";
import * as React from "react";
import { Button, CircularProgress, Typography } from "@material-ui/core";
import { GLOBALED_URL, GLOBALED_ORG_TOKEN/*, AUTH_PREFIX, JWT_TOKEN, SETTINGS*/, postApi } from "@cti-workspace/helpers";
//import jwt_decode from "jwt-decode";
import { useSnackbar } from "notistack";
import { userStore } from "../../store/userStore";
import uuid from "uuid";

function GlobalEdRedirect() {
  GlobalEdStyleRedirect( GLOBALED_URL, GLOBALED_ORG_TOKEN );
}

function GlobalEdStyleRedirect( redirectURL, orgToken ) {
	const userLogIn = userStore((state) => state.userLogIn);
	const { enqueueSnackbar } = useSnackbar();
	const [accountId, setaccountId] = useState("");

	useEffect(() => {
		let code = null;

		if (window.location.search) {
			//Check Query String
			const params = new URLSearchParams(window.location.search);
			code = params.get("code");
		} else {
			//Check Redirect URL
			const url = window.location.href;
			code = url.split("#code=").pop();
		}

		(async () => {
      let email = uuid()+'@cti3.com';
			try {
        const value = await userLogIn({
          email, password: "", organization: "", org_token: orgToken, auth_token: code
        }, null, true, false, null, {
          orgToken: orgToken,
          code: code,
        });
				console.log({ value });
				if (value) {
					let { dbAccount } = value;
					setaccountId(dbAccount._id);

					const capabilities = dbAccount.capabilities || null;
					console.log(capabilities);

					if (dbAccount && dbAccount.roles.length === 1 && dbAccount.roles.includes("holder")) {
						enqueueSnackbar("Login Success", { variant: "success" });
						if (!capabilities) {
							window.location.href = "/wallet";
						}
					}
				}
			} catch (error) {
				//Redirect back to GlobalEd with Error (The user email is not included or recognized)
        window.location.href = `${redirectURL}/mydashboard/wallet?token=${code}&code=406`;
				console.log(error);
			}
		})();
	}, []);
	return (
		<div
			style={{
				height: "100vh",
				width: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
			}}>
			<CircularProgress size={60} />
			<div style={{ textAlign: "center", marginTop: "10px" }}>
				<Typography variant="subtitle1" component="div" gutterBottom>
					The page is being loaded.
				</Typography>
				{/* <Button variant="outlined" onClick={() => Sentry.showReportDialog({ eventId: this.state.eventId })}>
						Report
					</Button> */}
			</div>
		</div>
	);
}

//function decryptCode(code) {}
export { GlobalEdRedirect };
export default { GlobalEdRedirect };
